import React, { FunctionComponent } from 'react';
import {ITypeOfWork} from "../../../models/inner-models";
import Chip from "@mui/material/Chip";

const TypeOfWork: FunctionComponent<ITypeOfWork> = ({ name }) => <Chip sx={{mr: 1.5, mb: 2}} label={name} variant="outlined" />

export default TypeOfWork;
